module.exports = __webpack_public_path__ + "static/media/notebook.3a078063.obj";